<form #form novalidate (ngSubmit)="steps.includes(numberSteps) ? checkChannelsLimitations() : continue()">
  <!-- TODO: Uncomment this when we use me/permissions  -->
  <!-- <div id="messageDetailContainer"
    class="container absolute top-20 right-0 hiddenDetails w-0 h-[calc(100vh-75px)] overflow-hidden flex flex-col"
    [ngClass]="{ 'openDetails': message && !edit && roleService.permissions['USER']['READ'], 'openDetailsEdit': message && edit && roleService.permissions['USER']['UPDATE'], 'expandedDetails': expanded}"> -->
  <div id="messagesDetailContainer" class="container absolute top-20 right-0 hiddenDetails w-0 h-[calc(100vh-75px)] overflow-hidden flex flex-col"
  [ngClass]="{ 'openDetails': message() || newMessage()}">
    <section class="topbar h-14 mt-4 flex items-center">
      <div class="mr-4 my-2 ml-6 justify-end ">
        <div class="flex main rounded-[50%] h-10 w-10 justify-center items-center"
          [ngClass]="{'hidden': !newMessage()}">
          <div [ngClass]="{ 'block': steps.includes(1), 'hidden': !steps.includes(1), 'quarter1': numberSteps === 3, 'half1': numberSteps === 2 }"></div>
          <div [ngClass]="{ 'block': steps.includes(2), 'hidden': !steps.includes(2), 'quarter2': numberSteps === 3, 'half2': numberSteps === 2 }"></div>
          <div class="quarter3" [ngClass]="{ 'block': steps.includes(3), 'hidden': !steps.includes(3) }"></div>
          <label class="flex font-bold text-base primary-purple-text cutout justify-center items-center">
            {{ currentStep }}/{{ numberSteps }}
          </label>
        </div>
      </div>
      <h1 class="ml-2 text-xl font-semibold primary-purple-text">
        {{ literalService.get(`messages.${newMessage() ? 'new' : 'message'}`, true) }}
      </h1>
      <section id="actions" class="flex ml-auto mr-8">
        <div class="flex items-center justify-center gap-2">
          <img [src]="images.close" alt="closeDetails" class="h-6 w-6 cursor-pointer" (click)="close()" [tooltip]="literalService.get('closeWindow', true)" [position]="TooltipPosition.BELOW" />
        </div>
      </section>
    </section>
    <section class="h-full !p-8 flex flex-col justify-between overflow-auto scrollable-content">
      <article id="body" class="pb-6">
        <div class="grid grid-rows-8 grid-flow-col gap-x-10" [ngClass]="{'!grid-rows-5': newMessage() && currentStep < numberSteps, '!grid-rows-9':  newMessage() && currentStep === numberSteps && message()?.receiver === MessageReceiver.EXPEDITION}">
          @for (element of messageForm; track element.id; ) {
            @if ((!newMessage() || !element.edit?.editable)) {
              <div class="mt-4"
                [ngClass]="{'hidden': element.hidden, 'row-span-2': element.edit && element.edit.inputType === InputType.LONG_TEXT && element.value.length >= 100 }">
                <app-detail
                  [data]="element"
                  [value]="element.value"
                  [extendable]="element.edit && element.edit.inputType === InputType.LONG_TEXT && element.value.length >= 100" />
              </div>
            }
            @else if (newMessage()) {
              <div class="mt-2 h-full" [ngClass]="{'row-span-2': element.edit.inputType === InputType.LONG_TEXT, 'hidden': element.hidden}">
                <app-input
                  [data]="element"
                  [edit]="true"
                  [independent]="false"
                  [translateValue]="element.edit?.translateValue"
                  [hasErrors]="invalid.includes(element.edit?.valueToChange)"
                  [error]="showError(element.value, element.edit?.valueToChange)"
                  (setEventEmitter)="changeData($event.value, element)"
                  (changeEventEmitter)="changeData($event.target, element)"
                  (scrollEventEmitter)="scroll($event, element.edit?.valueToChange)"
                  (searchEventEmitter)="search($event, element.edit?.valueToChange)"
                />
              </div>
            }
          }
        </div>
      </article>
      @if (newMessage()) {
        <section class="flex justify-center items-center">
          <div class="flex items-center w-full">
            <input type="button"
              class="secondary gap-4 border-2 font-semibold h-14 w-36 uppercase mr-2.5 cursor-pointer"
              [value]="literalService.get(currentStep === 1 ? 'cancel' : 'back')" (click)="currentStep === 1 ? cancel() : goBack()" />
            <input type="submit"
              class="primary text-white gap-4 border-2 font-semibold h-14 w-36 uppercase cursor-pointer"
              [disabled]="disabledSaveButton()"
              [value]="steps.includes(numberSteps) ? literalService.get('messages.send') : literalService.get('continue')" />
          </div>
        </section>
      }
    </section>
  </div>
</form>
<app-modal-confirmation
  [id]="'exceedReceiversModal'"
  [modal]="exceedReceiversModal"
  [icon]="images.messages.alert"
  [title]="'messages.modal.exceedReceivers.title'"
  [text]="exceedReceiversText"
  [sameLineButtons]="true"
  [centerText]="true"
  [confirmText]="'messages.modal.exceedReceivers.confirm'"
  [cancelText]="'messages.modal.exceedReceivers.cancel'"
  [confirmStyle]="'secondary'"
  [cancelStyle]="'primary'"
  (cancelAction)="close()"
  (action)="checkAdditionalCost()"
></app-modal-confirmation>
<app-modal-confirmation
  [id]="'additionalCostModal'"
  [modal]="additionalCostModal"
  [icon]="images.messages.alert"
  [title]="'messages.modal.additionalCost.title'"
  [text]="'messages.modal.additionalCost.description'"
  [sameLineButtons]="true"
  [centerText]="true"
  [confirmText]="'messages.modal.additionalCost.confirm'"
  [cancelText]="'messages.modal.additionalCost.cancel'"
  (cancelAction)="close()"
  (action)="onSubmit()"
></app-modal-confirmation>